'use strict';

export class BlockDashboardNewsCarousel {
  constructor() {
    console.log("Block carousel");
    var element = $(".block-views-blockdashboard-news-carousel-dashboard-carousel");

    if (element.length < 1) return;

    var currentBranch = $('.current_member_branch').data('branch');
    
    element.find(".branch_specific_slide").each(function() {
      if(!$(this).hasClass(currentBranch)) {
        $(this).closest('.views-row').remove();
      } else {
        $(this).addClass('.display');
      }
    });
    
    if (element.find(".views-row").length <= 1) return;

    
    element.find('.view-content').slick({
      dots: true,
      // autoplay: true,
      // autoplaySpeed: 2000,
      arrows: false,
      centerMode: false,
    });
  }
}
// 